import { Suit, Rank } from '@callbridge/engine';
import { getSuitColor, suitSymbols } from './SuitIcon.js';
/**
 * Display labels for card ranks.
 */
export const rankLabels = {
    [Rank.Two]: '2',
    [Rank.Three]: '3',
    [Rank.Four]: '4',
    [Rank.Five]: '5',
    [Rank.Six]: '6',
    [Rank.Seven]: '7',
    [Rank.Eight]: '8',
    [Rank.Nine]: '9',
    [Rank.Ten]: '10',
    [Rank.Jack]: 'J',
    [Rank.Queen]: 'Q',
    [Rank.King]: 'K',
    [Rank.Ace]: 'A',
};
/**
 * Full rank names for accessibility labels.
 */
export const rankNames = {
    [Rank.Two]: 'Two',
    [Rank.Three]: 'Three',
    [Rank.Four]: 'Four',
    [Rank.Five]: 'Five',
    [Rank.Six]: 'Six',
    [Rank.Seven]: 'Seven',
    [Rank.Eight]: 'Eight',
    [Rank.Nine]: 'Nine',
    [Rank.Ten]: 'Ten',
    [Rank.Jack]: 'Jack',
    [Rank.Queen]: 'Queen',
    [Rank.King]: 'King',
    [Rank.Ace]: 'Ace',
};
/**
 * Get all rendering data for a card face.
 *
 * @param card - The engine card object
 * @param state - Current visual state
 * @returns Complete data for rendering
 */
export function getCardFaceData(card, state = 'default') {
    const rankLabel = rankLabels[card.rank] ?? String(card.rank);
    const rankName = rankNames[card.rank] ?? String(card.rank);
    const suitName = card.suit.charAt(0).toUpperCase() + card.suit.slice(1);
    return {
        card,
        rankLabel,
        rankName,
        suitSymbol: suitSymbols[card.suit] ?? '',
        color: getSuitColor(card.suit),
        ariaLabel: `${rankName} of ${suitName}`,
        isFaceCard: card.rank >= Rank.Jack,
        state,
    };
}
/**
 * Sort key for visual display ordering.
 * Groups by suit (spades first as trump), then by rank descending.
 */
export function getCardSortKey(card) {
    const suitOrder = {
        [Suit.Spades]: 0,
        [Suit.Hearts]: 1,
        [Suit.Diamonds]: 2,
        [Suit.Clubs]: 3,
    };
    const suitValue = suitOrder[card.suit] ?? 4;
    // High rank first within each suit
    return suitValue * 100 + (15 - card.rank);
}
/**
 * Sort cards for display: grouped by suit, ranked high-to-low.
 */
export function sortCardsForDisplay(cards) {
    return [...cards].sort((a, b) => getCardSortKey(a) - getCardSortKey(b));
}
//# sourceMappingURL=CardFace.js.map